import type { BaseCreativeContent } from '../types'

/**
 * The edit pipeline's three honest states, derived from a creative's content:
 *
 *   'applying' - the layered Composition carries edits the flat master hasn't
 *                re-rendered yet (`compositionPendingRender`); a render is on its way
 *   'failed'   - that render reached a terminal failure (`compositionRenderFailed`,
 *                stamped server-side by the render endpoint, the AI revise, the
 *                publish-time render or the reaper); Retry re-renders the stored doc
 *   null       - the master is current
 *
 * Pure so every surface (cards, tiles, modals, the calendar's corner marker) derives
 * the same answer from the same two fields.
 */
export type EditsRenderState = 'applying' | 'failed' | null

export function editsRenderStateFromContent(
  content:
    | Pick<BaseCreativeContent, 'compositionPendingRender' | 'compositionRenderFailed'>
    | null
    | undefined
): EditsRenderState {
  if (content?.compositionPendingRender !== true) return null
  return content.compositionRenderFailed ? 'failed' : 'applying'
}

/** Combine two store readings: a failed anywhere wins over an applying elsewhere. */
export function mergeEditsRenderStates(a: EditsRenderState, b: EditsRenderState): EditsRenderState {
  if (a === 'failed' || b === 'failed') return 'failed'
  return a ?? b
}
